import React from 'react';
import classNames from 'classnames/bind';

import DimmedPopup from '@/components/CustomTravel/DimmedPopup';

import styles from './QuitRemindPopup.module.scss';

const cx = classNames.bind(styles);

interface QuitRemindPopupProps {
  onCancel: () => void;
  onContinue: () => void;
}

const QuitRemindPopup: React.FC<QuitRemindPopupProps> = ({ onCancel, onContinue }) => {
  return (
    <DimmedPopup>
      <div className={cx('QuitRemindPopup')} data-middle-popup>
        <div className={cx('title')}>
          상담 신청을
          <br />
          그만하시겠어요?
        </div>
        <span className={cx('description')}>여기서 상담 신청을 멈추시면 작성하신 내용이 모두 초기화됩니다.</span>
        <div className={cx('progress')}>
          <button type="button" className={cx('cancel')} onClick={onCancel}>
            닫기
          </button>
          <button type="button" className={cx('continue')} onClick={onContinue}>
            계속하기
          </button>
        </div>
      </div>
    </DimmedPopup>
  );
};

export default QuitRemindPopup;
